import { useTopicAuto } from "@hooks/selectors/user/support.selectors";
import { FC } from "react";
import { Text } from '@components/constructor/components';
import { fromUtcDate } from "@services/helpers";

interface SupportTopicUpdateTimeProps {
    format?: string;
}

const SupportTopicUpdateTime: FC<SupportTopicUpdateTimeProps> = ({ format = 'lll', ...props }) => {
    const topic = useTopicAuto();

    if (!topic) {
        return null;
    }

    return (
        <Text text={fromUtcDate(topic.updateTime).format(format)} {...props} />
    )
}

export default SupportTopicUpdateTime;